export default __webpack_public_path__ + "static/flicker-0294bb27b9948fde39acad6921da6d33.woff2";